<template>
  <card-seplag :titulo="'Holerite'" cor="#00acc1">
    <div class="p-lg-12 p-col-12 dashboard">
      <div class="summary-box summary-box-azul">
        <Card class="card">
          <template slot="content">
            <div class="p-grid">
              <div class="p-col-1 col-imagem">
                <i class="pi pi-user summary-box-icon"></i>
              </div>
              <div class="p-col-md-11 p-col-sm-12">
                <p class="summary-box-title">{{ dadosPessoa.nome }}</p>
                <p><strong>CPF:</strong> {{ dadosPessoa.cpfFormatado }}</p>
                <p><strong>RG:</strong> {{ dadosPessoa.rg }}</p>
                <p v-if="!numPensionista">
                  <strong>Matrícula:</strong> {{ dadosPessoa.matricula }}
                </p>
                <p v-if="!numPensionista">
                  <strong>Vínculo:</strong> {{ this.vinculo }}
                </p>
                <p v-else>
                  <strong
                    >Vinculo Referente a Pensão de
                    {{ this.pessoaPensionista }}</strong
                  >
                </p>
              </div>
            </div>
            <img
              src="../../../public/assets/layout/images/tmp/graph-messages.svg"
              alt="sapphire"
              class="summary-box-graph"
              width="20%"
            />
          </template>
        </Card>
      </div>
    </div>
    <Fieldset class="p-col-12" legend="Contra Cheque">
      <div class="p-grid p-align-center">
        <div class="p-md-4 p-col-12">
          <Dropdown
            v-model="mesFolhaSelected"
            :options="mesesFolha"
            optionLabel="combo"
            placeholder="Selecione o mês da folha"
            @input="carregarFolha()"
          />
        </div>
        <DataTable
          :value="holerite"
          class="p-md-7 p-col-12 p-md-offset-1 p-datatable-responsive"
        >
          <Column
            field="mesAnoFolha"
            header="Mês/Ano"
            :bodyStyle="'text-align:center'"
            :headerStyle="'width: 20%;'"
          ></Column>
          <Column
            field="numero"
            header="Nº Folha"
            :bodyStyle="'text-align:center'"
            :headerStyle="'width: 20%;'"
          >
          </Column>
          <Column
            field="folhaFechamento.nomeFolha"
            header="Folha"
            :bodyStyle="'text-align:center'"
          ></Column>
        </DataTable>

        <DataTable :value="rubricas" class="p-col-12 p-datatable-responsive">
          <Column
            field="rubricas.codigoRubrica"
            class="p-col-1"
            header="Rubrica"
            bodyStyle="text-align:center;"
            headerStyle="width:11%;"
          ></Column>
          <Column
            field="rubricas.nomeRubrica"
            class="p-col-2"
            header="Nome Abreviado"
            bodyStyle="text-align:center;"
            headerStyle="width:20%;"
          ></Column>
          <Column
            field="complemento"
            class="p-col-2"
            header="Complemento"
            bodyStyle="text-align:center; "
            headerStyle="width:16%;"
          ></Column>
          <Column
            field="competencia"
            class="p-col-1"
            header="Competência"
            bodyStyle="text-align:center;"
            headerStyle="width:13%;"
          ></Column>
          <Column
            field="vantagem"
            class="p-col-2"
            header="Vantagem"
            bodyStyle="text-align:center;"
            headerStyle="width:13%;"
          ></Column>
          <Column
            field="desconto"
            class="p-col-2"
            header="Desconto"
            bodyStyle="text-align:center;"
            headerStyle="width:13%;"
          ></Column>
          <Column
            field="informacoes"
            class="p-col-2"
            header="Info p/ contrachaque"
            bodyStyle="text-align:center;"
            headerStyle="width:14%;"
          ></Column>
        </DataTable>
        <div
          class="p-col-12 p-grid p-fluid p-align-center p-justify-center"
          style="font-weight: bold; margin-top: 5px"
        >
          <div
            class="p-col-12 p-md-4 p-grid p-fluid p-align-center p-justify-center"
          >
            {{ this.totais.bruto }}
          </div>
          <div
            class="p-col-12 p-md-4 p-grid p-fluid p-align-center p-justify-center"
          >
            {{ this.totais.descontos }}
          </div>
          <div
            class="p-col-12 p-md-4 p-grid p-fluid p-align-center p-justify-center"
          >
            {{ this.totais.liquido }}
          </div>
        </div>
      </div>
    </Fieldset>
    <div class="p-col-12 p-md-6 p-md-offset-5">
      <div class="p-col-12 p-md-5 p-md-offset-9" v-if="holerite.length > 0">
        <Button
          label="Gerar PDF"
          icon="pi pi-file-pdf"
          @click="gerarPDF"
          class="p-button-primary"
        />
      </div>
    </div>

    <CardExibirPDF
      v-if="pdfElement && navegador != 'Safari'"
      v-model="exibirPDF"
      :nomeDocumento="nomeDocumentoPDF"
      :tituloTela="'PDF do Holerite Selecionado'"
      :position="'top'"
      :tamanhoTela="'55.em'"
      :alturaTela="'55.em'"
      :pdfElement="pdfElement"
    />
  </card-seplag>
</template>

<script>
import CardSeplag from "@/template/CardSeplag.vue";
import CardExibirPDF from "@/template/CardExibirPDF.vue";
import moment from "moment";
import { baseApiUrl } from "@/config/global";
export default {
  name: "Holerite",
  components: { CardSeplag, CardExibirPDF },
  data: function () {
    return {
      apiUrlRecurso: "holerites",
      mesesFolha: [],
      dadosPessoa: [],
      mesFolhaSelected: null,
      holerite: [],
      rubricas: [],
      totais: [],
      numPensionista: null,
      pessoaPensionista: null,
      matricula: null,
      vinculo: null,
      desabilitado: true,
      exibirPDF: false,
      nomeDocumentoPDF: "holerite",
      pdfElement: null,
      navegador: null,
    };
  },
  mounted() {
    this.carregarDados();
  },
  methods: {
    calcularTotais() {
      let totalBruto = 0;
      let totalDescontos = 0;
      let totalLiquido = 0;
      if (this.rubricas) {
        for (let rub of this.rubricas) {
          totalBruto += rub.valorVantagem;
          totalDescontos += rub.valorDesconto;
        }
        totalLiquido = totalBruto - totalDescontos;
      }

      this.totais = {
        bruto:
          "Total Bruto: " +
          totalBruto.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            style: "currency",
            currency: "BRL",
          }),
        descontos:
          "Total Descontos: " +
          totalDescontos.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            style: "currency",
            currency: "BRL",
          }),
        liquido:
          "Total Liquido: " +
          totalLiquido.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            style: "currency",
            currency: "BRL",
          }),
      };
    },
    async carregarDados() {
      this.matricula = await this.$store.getters.getMatricula;
      this.vinculo = await this.$store.getters.getVinculo;
      var usuario = this.$store.getters.getUser;
      if (this.$store.getters.getIsPensionista) {
        this.matricula =
          usuario.dadosUsuariosCustomizados.vinculoERP.vinculoServidor.numrMatricula;
        this.pessoaPensionista =
          usuario.dadosUsuariosCustomizados.vinculoERP.vinculoServidor.pessoa.nomePessoa;
      }
      this.numPensionista =
        usuario.dadosUsuariosCustomizados.vinculoERP &&
        usuario.dadosUsuariosCustomizados.vinculoERP.numrPensionista > 0
          ? usuario.dadosUsuariosCustomizados.vinculoERP.numrPensionista
          : null;

      this.dadosPessoa = {
        matricula: this.matricula,
        vinculo: this.vinculo,
        cpf: usuario.contaAcesso.pessoa.numrCpf,
        rg: usuario.contaAcesso.pessoa.numrRg,
        nome: usuario.contaAcesso.pessoa.nomePessoa,
        cpfFormatado: this.formatarCPF(usuario.contaAcesso.pessoa.numrCpf),
      };
      var dataAtual = moment().format("DD/MM/YYYY");
      var mesfolhaoptions = {
        matricula: this.matricula,
        vinculo: this.vinculo,
        mesAno: dataAtual,
        numPensionista: this.numPensionista,
      };

      var v_mesesFolha = await this.$http.post(
        `${baseApiUrl}/${this.apiUrlRecurso}/mesano`,
        JSON.stringify(mesfolhaoptions)
      );
      if (v_mesesFolha.status == 200) {
        this.mesesFolha = v_mesesFolha.data;

        this.mesesFolha = this.mesesFolha.map((item) => {
          if (
            this.mesesFolha.filter((element) => element.combo == item.combo)
              .length > 1
          ) {
            return {
              ...item,
              combo: `${item.combo} FOLHA ${item.numeroFolha}`,
            };
          }
          return item;
        });

        if (this.mesesFolha.length > 0) {
          this.mesFolhaSelected = this.mesesFolha[0];
          this.carregarFolha();
        }
      }
    },
    async carregarFolha() {
      var folhaSelecionada = {
        numFolha: this.mesFolhaSelected.numeroFolha,
        matricula: this.matricula,
        vinculo: this.vinculo,
        mesAno: this.mesFolhaSelected.mesAno,
        mesAnoString: this.mesFolhaSelected.mesAno,
        numPensionista: this.numPensionista,
      };

      var v_holerite = await this.$http.post(
        `${baseApiUrl}/${this.apiUrlRecurso}`,
        JSON.stringify(folhaSelecionada)
      );
      if (v_holerite.status == 200) {
        this.holerite = v_holerite.data;
        this.rubricas = this.holerite[0].holeriteRubricaLista;
        this.calcularTotais();
      }
    },
    detectaNavegador() {
      var isOpera = !!window.opera || navigator.userAgent.indexOf(" OPR/") >= 0;
      var isFirefox = typeof InstallTrigger !== "undefined"; // Firefox 1.0+
      var isChrome = !!window.chrome && !isOpera; // Chrome 1+
      var isIE = /*@cc_on!@*/ false || !!document.documentMode; // At least IE6

      var userAgent = navigator.userAgent;
      var isSafari =
        userAgent.indexOf("Safari") >= 0 && userAgent.indexOf("Chrome") === -1;

      if (isOpera) {
        this.navegador = "Opera";
        return 1;
      } else if (isFirefox) {
        this.navegador = "Firefox";
        return 2;
      } else if (isChrome) {
        this.navegador = "Chrome";
        return 3;
      } else if (isSafari) {
        this.navegador = "Safari";
        return 4;
      } else if (isIE) {
        this.navegador = "IE";
        return 5;
      } else {
        this.navegador = "OUTRO";
        return 0;
      }
    },
    formatarCPF(cpf) {
      // Remove qualquer caractere não numérico
      let numeros = String(cpf).replace(/\D/g, "");

      // Adiciona zeros à esquerda se tiver menos de 11 dígitos
      numeros = numeros.padStart(11, "0");

      // Aplica a máscara de CPF: 000.000.000-00
      return numeros.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },
    gerarPDF() {
      let dadosPDF = {
        matricula: this.$store.getters.getMatricula,
        vinculo: this.$store.getters.getVinculo,
        mesAno: this.holerite[0].mesAno,
        numeroFicha: this.holerite[0].ficha,
        numPensionista: this.numPensionista,
      };
      setTimeout(this.downloadPDF(dadosPDF), 500);
    },
    downloadPDF(dadosPDF) {
      this.$http
        .post(`${baseApiUrl}/holerites/pdf`, JSON.stringify(dadosPDF))
        .then((res) => {
          this.pdfElement = res.data.dadosRelatorioBase64;
          this.nomeDocumentoPDF = res.data.nomeArquivo;
          this.exibirPDF = true;

          const byteCharacters = atob(res.data.dadosRelatorioBase64);
          const byteNumbers = new Array(byteCharacters.length);

          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "application/pdf" });

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, "fichafinaceira.pdf");
          } else {
            const objectUrl = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = objectUrl;
            link.download = "holerite.pdf";
            link.style.display = "none";

            if (this.detectaNavegador() === 4) {
              this.exibirPDF = false;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              setTimeout(() => {
                window.open(objectUrl, "_blank");
              }, 1000);
            }

            setTimeout(() => {
              URL.revokeObjectURL(objectUrl);
            }, 2000);
          }
        });
    },
  },
};
</script>

<style>
.dashboard .dashboard-grid {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding: 0;
}

.dashboard .card {
  height: 100%;
  margin-bottom: 0;
}

.dashboard .summary-box {
  position: relative;
}

.dashboard .summary-box .card {
  min-height: 100px;
}

.dashboard .summary-box .summary-box-title {
  font-size: 2em;
  margin: 0;
  color: #ffffff;
}

.dashboard .summary-box p {
  margin: 0.25em 0;
  color: #ffffff;
}

.col-imagem {
  display: inline;
}

.dashboard .summary-box .summary-box-icon {
  font-size: 8em;
  color: #ffffff;
}

.dashboard .summary-box .summary-box-graph {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.dashboard .summary-box.summary-box-azul .card {
  border-top: 4px solid #0097a7;
  background-color: #00bcd4;
}

.dashboard .summary-box.summary-box-azul .ico {
  color: #0097a7;
}

@media screen and (max-width: 1600px) {
  .dashboard .summary-box .summary-box-icon {
    font-size: 6em;
    margin-top: 27px;
  }

  .col-imagem {
    display: none;
  }
}

@media screen and (max-width: 780px) {
  body .p-component {
    font-size: 12px;
  }

  .p-datatable-responsive .p-datatable-thead > tr > th,
  .p-datatable-responsive .p-datatable-tfoot > tr > td {
    display: none !important;
  }

  .p-datatable-responsive .p-datatable-tbody > tr > td {
    text-align: left;
    display: block;
    border: 0 none;
    width: 100% !important;
    float: left;
    clear: left;
  }

  .p-datatable-responsive .p-datatable-tbody > tr > td .p-column-title {
    padding: 0.4em;
    min-width: 30%;
    display: inline-block;
    margin: -0.4em 1em -0.4em -0.4em;
    font-weight: bold;
  }

  body .p-datatable .p-datatable-header {
    border-bottom: 1px solid #c8c8c8;
  }
}
</style>
